<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Secondarydealerfilestable from './components/secondarydealerfilestable.vue'
	import {
		CustomerList,
		CustomerExport,
		GetCusType,
		InventoryClassList,
		GetProvince
	} from '@/api/home'
	import utils from '../../../common/utils'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable
		},
		data() {
			return {
				dialogVisibles: false,
				showorhide: true,
				cusCode: "",
				cusName: "",
				cusType: "",
				actived: "",
				LicenseStatus: "",
				CreateTime1: "",
				CreateTime2: "",
				LicenseWarningDays1: "",
				LicenseWarningDays2: "",
				BusinessProvinceIDs: "",
				InvClass: "",
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				formdata: [{
						inputdata: '',
						title: '客户编号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '230px'
					},
					{
						inputdata: '',
						title: '客户名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '230px',
						lablewith: '102px',
					},
					{
						inputdata: '',
						title: '客户类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: []
					},
					{
						inputdata: '',
						title: '质量状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						options: [{
								key: '0',
								value: '停用'
							},
							{
								key: '1',
								value: '启用'
							},
						]
					},
					{
						inputdata: '',
						title: '证照状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						lablewith: '80px',
						options: [{
								key: '1',
								value: '有效证照'
							},
							{
								key: '0',
								value: '待审证照'
							},
							{
								key: '-1',
								value: '驳回证照'
							},
							{
								key: '-2',
								value: '未上传证照'
							}
						]
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '240px',
						lablewith: '100px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "dateSection",
						widthLeft: 240,
						widthRight: 300,
						heightLeft: 32,
						heightRight: 32,
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '证照近效期天数',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: '',
						inputtype: 'numbers',
						width: '74px',
						lablewith: '95px',
						minleft: 0,
						// maxleft: und,
						minrigth: 0,
						// maxrigth: 100
						lablewith: '105px'
					},
					{
						inputdata: "",
						title: "省份",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "210px",
						btx: true,
						lablewith: '60px',
						options: [],
						disabled: true
					},
				]
			}
		},
		mounted() {
			this.customerList()
			this.getCusType()
			this.inventoryClassList()
			this.getProvince();
		},
		methods: {
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[8].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[8].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			// 列表
			async customerList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await CustomerList({
					cusCode: this.cusCode,
					cusName: this.cusName,
					cusType: this.cusType == "全部" ? "" : this.cusType,
					actived: this.actived == "全部" ? "" : this.actived,
					LicenseStatus: this.LicenseStatus,
					InvClass: this.InvClass,
					CreateTime1: this.CreateTime1,
					CreateTime2: this.CreateTime2,
					LicenseWarningDays1: this.LicenseWarningDays1,
					LicenseWarningDays2: this.LicenseWarningDays2,
					BusinessProvinceIDs: this.BusinessProvinceIDs,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data.map(it => {
							it.BLBusinessStartDate = it.BLBusinessStartDate ? it.BLBusinessStartDate.substring(
								0, 10) : '';
							it.BLBusinessEndDate = it.BLBusinessEndDate ? it.BLBusinessEndDate.substring(0,
								10) : '';
							return it;
						})
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async customerExport() {
				let resexprot = await CustomerExport({
					cusCode: this.cusCode,
					cusName: this.cusName,
					cusType: this.cusType == "全部" ? "" : this.cusType,
					actived: this.actived == "全部" ? "" : this.actived,
					LicenseStatus: this.LicenseStatus,
					InvClass: this.InvClass,
					CreateTime1: this.CreateTime1,
					CreateTime2: this.CreateTime2,
					LicenseWarningDays1: this.LicenseWarningDays1,
					LicenseWarningDays2: this.LicenseWarningDays2,
					BusinessProvinceIDs: this.BusinessProvinceIDs,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					utils.downloadFile(resexprot, "二级经销商报表", "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}

				//console.log(resexprot, "resexprot")
			},
			Export() {
				this.customerExport()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.formdata[5].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.formdata[5].options.push(obj);
					});
				}
			},
			async getCusType() {
				let {
					code,
					data
				} = await GetCusType({

				})
				if (code == 0) {
					this.formdata[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[2].options.push(obj)
					})
				}

			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					if (index == 6) {
						item.startTime = ""
						item.endTime = ""
					}
					if (index == 7) {
						item.modelvalueleft = undefined
						item.modelvalueright = undefined
					}
					item.modelvalue = ''
				})
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			select() {
				this.pageindex = 1
				try {
					this.cusCode = this.$refs.seselect[0].modelvalue
					this.cusName = this.$refs.seselect[1].modelvalue
					this.cusType = this.$refs.seselect[2].modelvalue
					this.actived = this.$refs.seselect[3].modelvalue
					this.CreateTime1 = this.$refs.seselect[6].endTime
					this.CreateTime2 = this.$refs.seselect[6].startTime
					this.LicenseWarningDays1 = this.$refs.seselect[7].modelvalueleft
					this.LicenseWarningDays2 = this.$refs.seselect[7].modelvalueright
					this.LicenseStatus = this.$refs.seselect[4].modelvalue
					this.InvClass = this.$refs.seselect[5].modelvalue
					this.BusinessProvinceIDs = this.$refs.seselect[8].modelvalue.length ? this.$refs.seselect[8].modelvalue
						.join(',') : ''
					this.customerList()
				} catch (error) {
					this.customerList()
				}
			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.customerList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.customerList()

			},
		},
		watch: {
			$route: {
				handler(to, from) {
					// 处理跳转操作
					let CusCode = to.query.CusCode
					if (CusCode) {
						this.formdata[0].inputdata = CusCode
						this.cusCode = CusCode
						this.saleBillList()
						return
					}
					this.customerList()
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 90px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>